import { useContext, useLayoutEffect, useMemo, useState } from 'react'
import ReactDOM from 'react-dom'
import { ConnectionStatus, StateSyncStatus } from './utils'
import cx from 'classnames'
import Styles from './TitleBarSaveStatus.module.scss'
import { ReactComponent as OfflineIcon } from 'assets/icons/offline-cloud16.svg'
import { ReactComponent as SavedIcon } from 'assets/icons/save-cloud16.svg'
import { Spinner } from 'common/Spinner/Spinner'
import { observer } from 'mobx-react-lite'
import { CollabStateContext } from 'stores/CollabState'
import { useQueryParams } from 'hooks/useQueryParams'

export const TITLE_BAR_SAVE_STATUS_CONTAINER_ID = 'title-bar-save-status-container-id'

export const PortalTitleBarSaveStatus = observer(function PortalTitleBarSaveStatus() {
  const renderContainer = useMemo(() => document.createElement('div'), [])

  useLayoutEffect(() => {
    const externalMount = document.getElementById(TITLE_BAR_SAVE_STATUS_CONTAINER_ID)
    externalMount?.appendChild(renderContainer)

    return () => {
      externalMount?.removeChild(renderContainer)
    }
  }, [renderContainer])

  return ReactDOM.createPortal(<TitleBarSaveStatus />, renderContainer)
})

const TitleBarSaveStatus = observer(function TitleBarSaveStatus() {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { saveStatus, connStatus } = useContext(CollabStateContext)!
  const { hideConnecting } = useQueryParams()

  const [prevSyncStatus, setPrevSyncStatus] = useState(saveStatus)
  let statusMessage = null

  if (saveStatus !== prevSyncStatus) {
    if (saveStatus === StateSyncStatus.UpToDate && prevSyncStatus === StateSyncStatus.Behind) {
      setTimeout(() => setPrevSyncStatus(saveStatus), 3000)
    } else {
      setPrevSyncStatus(saveStatus)
    }
  }

  if (saveStatus === StateSyncStatus.Behind) {
    statusMessage = (
      <>
        <Spinner className={Styles.icon} />
        Saving...
      </>
    )
  } else if ([ConnectionStatus.Connecting, ConnectionStatus.Offline].includes(connStatus)) {
    statusMessage = !hideConnecting && (
      <>
        <Spinner className={Styles.icon} />
        Connecting...
      </>
    )
  } else if (saveStatus === StateSyncStatus.UpToDate && prevSyncStatus === StateSyncStatus.Behind) {
    statusMessage = (
      <div className={cx(Styles.savedIcon)}>
        <SavedIcon className={cx(Styles.icon, Styles.noFill)} />
        Saved
      </div>
    )
  } else if (connStatus === ConnectionStatus.LongConnecting) {
    statusMessage = (
      <>
        <OfflineIcon className={cx(Styles.icon)} />
        Offline
      </>
    )
  }

  return <div className={cx(Styles.container)}>{statusMessage}</div>
})
